module.exports = __webpack_public_path__ + "img/log-out.c7413a33.svg";